/**
 * Optional metadata attached to TanStack Router routes via `staticData`.
 */
export type AppRouteStaticData = {
	/** i18n key for the leaf breadcrumb segment on sub-pages */
	breadcrumbKey?: string
}

declare module "@tanstack/react-router" {
	interface StaticDataRouteOption extends AppRouteStaticData {}
}

export function getLeafBreadcrumbKeyFromMatches(
	matches: Array<{ staticData?: AppRouteStaticData }>,
): string | undefined {
	for (let index = matches.length - 1; index >= 0; index -= 1) {
		const breadcrumbKey = matches[index]?.staticData?.breadcrumbKey
		if (breadcrumbKey) {
			return breadcrumbKey
		}
	}

	return undefined
}
